import styled from '@emotion/styled';
import styleUtils from '../../../styles/utils';

export const ButtonContentRoot = styled('span')`
  ${({ hasIcon }) => (hasIcon ? styleUtils.flex.container() : null)}
`;

export const IconContainerLeft = styled('span')`
  ${styleUtils.flex.container()};
  margin-right: 7px;
`;

export const IconContainerRight = styled('span')`
  ${styleUtils.flex.container()};
  margin-left: 7px;
`;
